module.exports = __webpack_public_path__ + "static/media/hp-home-banner-@2x.35cdff1c.jpg";